import Vue from "vue";
import VueAuth from "@websanova/vue-auth";
import HttpDriver from "@websanova/vue-auth/drivers/http/axios.1.x";
import VueRouterDriver from "@websanova/vue-auth/drivers/router/vue-router.2.x";

import config from "./config";

const authDriver = {
  request: function(req, token) {
    this.options.http._setHeaders.call(this, req, {
      Authorization: "Bearer " + token
    });
  },
  response: res => {
    if (res.data.accessToken) {
      return res.data.accessToken;
    }
  }
  // example below for including refresh token, expiry etc.
  // response(res) {
  //   const { access_token, refresh_token, expires_in } = res.data;
  //   if (res.data && access_token && refresh_token && expires_in) {
  //     /*get tokens if none present then*/
  //     let expires_inDate = new Date();
  //     /*get exact time of expiration token*/
  //     expires_inDate.setSeconds(expires_inDate.getSeconds() + expires_in);
  //     localStorage.setItem("expires_in", expires_inDate);
  //     localStorage.setItem("refresh_token", refresh_token);
  //     return access_token;
  //   }
  // }
};

export default function() {
  Vue.use(VueAuth, {
    parseUserData(data) {
      return data;
    },
    auth: authDriver,
    http: HttpDriver,
    router: VueRouterDriver,
    token: [
      {
        request: "Authorization",
        response: "Authorization",
        authType: "bearer",
        foundIn: "header"
      },
      {
        request: "token",
        response: "accessToken",
        authType: "bearer",
        foundIn: "response"
      }
    ],
    tokenImpersonateName: "impersonate_access_token",
    tokenDefaultName: "access_token",
    tokenStore: ["localStorage", "cookie"],
    rolesVar: "role",
    authRedirect: { path: "/login" },
    forbiddenRedirect: { path: "/403" },
    notFoundRedirect: { path: "/404" },
    registerData: {
      headers: {
        "Content-Type": "application/json"
      },
      url: "v1/users",
      method: "POST",
      redirect: "/"
    },
    loginData: {
      headers: {
        "Content-Type": "application/json"
      },
      data: {
        grantType: "password"
      },
      url: "v1/tokens",
      method: "POST",
      redirect: "/",
      rememberMe: true,
      fetchUser: true
    },
    logoutData: {
      success: function() {
        // clear any local storage
        Vue.ls.clear();
      },
      redirect: "/login"
    },
    fetchData: {
      url: "v1/users/current",
      method: "GET",
      enabled: true
    },
    /*Default refresh request data and redirect.*/
    refreshData: {
      /*send refresh token before expiring to renew tokens*/
      url: "v1/tokens",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      data: {
        grantType: "refresh_token",
        refresh_token: getRefreshToken()
      },
      enabled: false,
      interval: 0 /*0=no auto refresh*/,
      /*Problem: requests new refresh token without checking the expiration date*/
      fetchUser: false
    },
    tokenExpired() {
      const expires_in = localStorage.getItem("expires_in");
      const now = new Date();
      const isExpired = expires_in && new Date(expires_in) < now;
      if (isExpired) {
        Vue.auth.options.refreshData.data = querystring.stringify({
          grant_type: "refresh_token",
          refresh_token: getRefreshToken()
        });
      }
      return isExpired;
    },
    cookieDomain() {
      return config.cookieDomain;
    }
  });
}

function getRefreshToken() {
  return localStorage.getItem("refresh_token");
}
